export const InqueryIdAcctionsTypes = {
    SET_INQUIRY_ID: "SET_INQUIRY_ID",
  };
  